export default __webpack_public_path__ + "static/media/man-lang-freisteller.7b32f776.png";